<template>
  <div>
    <section class="permanently-close-acc">
      <div class="sidebar-container"></div>
      <div class="main-contents">
        <ul class="breadcrumbs-list">
          <a href="javascript:void(0)" @click="backButton"
            ><li>User Profile</li></a
          >
          <li>&nbsp;>&nbsp;Account Management</li>
        </ul>
        <h2>Permanently Close Account</h2>
        <v-card>
          <p>
            Hi {{name}}, we are sorry to see you discontinue your financial wellness
            journey.
          </p>
          <p>
            Do note that permanently deleting the account will erase all
            investment related details including personal details of yours and
            your family members if any.
          </p>
          <p>There will be no part refund of the subscription fee paid.</p>
          <p>
            All service if availed will be discontinued immediately and you will
            not able to log-in. In case you decide to subscribe to our
            application at a future date you have to sign-up again and pay
            subscription fee prevailing at that point in time.
          </p>
          <p>
            Should you want to proceed with permanent closure of account, please
            click “Proceed” below. You will receive a confirmation on your email
            id.
          </p>

          <div class="button-container">
            <!-- <router-link to="/Dashboard">
              <button class="nemia-button">CANCEL</button></router-link
            > -->
              <button class="nemia-button" @click="backButton">CANCEL</button>

            <button class="nemia-button active" @click="otpPage()">
              PROCEED
            </button>
          </div>
        </v-card>
      </div>
    </section>
  </div>
</template>
<script>
import { VERIFY_MOBILE_OTP, SEND_MOBILE_OTP,VERIFY_EMAIL_OTP } from "../../store/actions.type";
export default {
  name: "PermanentlyCloseAccount",
  data: () => ({
      name:''
  }),
  methods: {
     backButton() {
      this.$router.push("/Dashboard");
    },
    otpPage() {
      this.$router.push("/OtpVarification?page=deletion");
      this.$loading(true);
      this.$store.dispatch(VERIFY_EMAIL_OTP, {
          data:{
            mobile_no:this.$store.getters.getUserDetails.mobile_no,
            aws_cognito_id:atob(localStorage.getItem('cognito_idp')),
          },
          api:'send-otp',
        })
        .then(()=> {
          this.$loading(false);
          if (this.$store.getters.getVerifyEmailOtp.data.status == 'error') {
              return [];
          }else{
            swal.fire({
            title: '',
            text: "OTP sent successfully",
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            confirmButtonText: 'OK',
          }).then((result) => {
            this.$loading(false);
          })   
          }
        })
        .catch((error)=> {
          this.$loading(false);
        });
    },
  },
  mounted() {
            this.name = this.$store.getters.getUserSignin.data.name;

  },
};
</script>

<style>
</style>
